import { AlertService } from "../../services/alerts/service";
import { alertDataFromJson } from "../../domain/alerts/mapper";
import { alertRulesFromJson } from "../../domain/alerts/rules/mapper";

const alertService = new AlertService(
  alertDataFromJson,
  alertRulesFromJson,
  localStorage.getItem("basicUrl")
);

const getDefaultState = () => {
  return {
    alerts: [],
    categories: [
      {
        id: null,
        name: "All",
        description: "Show all alerts",
        icon: "mdi-alert-circle",
        color: "error",
      },
      {
        id: 1,
        name: "Fouling",
        description: "Critical system notifications",
        icon: "mdi-sprout",
        color: "success",
      },
      {
        id: 2,
        name: "Engine",
        description: "Performance related issues",
        icon: "mdi-engine",
        color: "warning",
      },
      {
        id: 3,
        name: "Operation",
        description: "Scheduled maintenance notifications",
        icon: "mdi-factory",
        color: "info",
      },
      {
        id: 4,
        name: "Sensor Faults",
        description: "Scheduled maintenance notifications",
        icon: "mdi-leak-off",
        color: "warning",
      },
    ],
    selectedCategory: null,
    fetchLoading: true,
    fetchError: null,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
    updateFailed: false,
  };
};

const state = getDefaultState();

const getters = {
  filteredAlerts: (state) => {
    if (state.selectedCategory === null) {
      return state.alerts;
    }
    return state.alerts.filter((alert) => alert.categoryId === state.selectedCategory);
  },
  fetchRequestFailed: (state) => (state.fetchError != null),
  updateRequestFailed: (state) => (state.updateError != null),
};

const actions = {
  async fetchAlerts({ commit }, vesselName) {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const alerts = await alertService.getMany(
        localStorage.getItem("quad_token"),
        vesselName
      );
      commit("SET_FETCH_SUCCESS_STATE", alerts);
    } catch (error) {
      commit("SET_FETCH_FAILED_STATE");
    }
  },

  async updateAlerts({ commit }, updates) {
    commit("SET_UPDATE_LOADING_STATE");
    try {
      const updatedAlerts = await alertService.updateMany(
        localStorage.getItem("quad_token"),
        updates
      );
      commit("SET_UPDATE_SUCCESS_STATE", updatedAlerts);
    } catch (error) {
      commit("SET_UPDATE_FAILED_STATE");
    }
  }
};

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ALL_ALERTS: (state, data) => (state.alerts = data),
  SET_ALL_CATEGORIES: (state, data) => (state.categories = data),
  SET_SELECTED_CATEGORY: (state, data) => (state.selectedCategory = data),
  SET_ALERT_UPPER_LIMIT(state, data) {
    const alertId = data.id;
    const newUpperLimit = data.upperLimit;
    const alert = state.alerts.find((alert) => alert.id === alertId);
    alert.upperLimit = newUpperLimit;
  },
  SET_ALERT_LOWER_LIMIT(state, data) {
    const alertId = data.id;
    const newLowerLimit = data.lowerLimit;
    const alert = state.alerts.find((alert) => alert.id === alertId);
    alert.lowerLimit = newLowerLimit;
  },
  SET_ALERT_ENABLED(state, data) {
    const alertId = data.id;
    const newEnabled = data.enabled;
    const alert = state.alerts.find((alert) => alert.id === alertId);
    alert.enabled = newEnabled;
  },
  SET_ALERT_SEND_EMAIL(state, data) {
    const alertId = data.id;
    const newSendEmail = data.sendEmail;
    const alert = state.alerts.find((alert) => alert.id === alertId);
    alert.sendEmail = newSendEmail;
  },
  SET_ALERT_RECEIVER_EMAIL(state, data) {
    const alertId = data.id;
    const newReceiverEmail = data.receiverEmail;
    const alert = state.alerts.find((alert) => alert.id === alertId);
    alert.receiverEmail = newReceiverEmail;
  },
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_FAILED_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch alerts";
  },
  SET_FETCH_SUCCESS_STATE(state, data) {
    state.fetchLoading = false;
    state.fetchError = null;
    state.alerts = data;
  },
  SET_UPDATE_LOADING_STATE(state) {
    state.updateLoading = true;
    state.updateError = null;
    state.updateSuccess = false;
    state.updateFailed = false;
  },
  SET_UPDATE_FAILED_STATE(state) {
    state.updateLoading = false;
    state.updateError = "Could not update alerts";

    state.updateSuccess = false;
    state.updateFailed = true;
  },
  SET_UPDATE_SUCCESS_STATE(state, data) {
    state.updateLoading = false;
    state.updateError = null;
    state.alerts = data;

    state.updateSuccess = true;
    state.updateFailed = false;
  }
};

export const alertsModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
